module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/194-malta-bd182ab984b367b56955bc4d1bae5136.svg";